import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { getParameterValue } from "@core/utils";
import { ROUTER_UTILS } from '@core/utils/router.utils';
import { AuthService } from '@services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad {
  constructor(private router: Router, private authService: AuthService, private location: Location) {}

  canLoad(route: Route, segments: UrlSegment[]): boolean {
    const isSearch = this.getSearchParam();
    const isLoggedIn = this.authService.isLoggedIn;
    // 如果是smb不校验是否已登录
    if (isLoggedIn || (route.path?.indexOf('smb') !== -1 && isSearch)) {
      return true;
    }

    const returnUrl = this.location.path(true);
    const { root, login } = ROUTER_UTILS.config.auth;

    this.router.navigate(['/', root, login], { queryParams: { returnUrl }, state: { returnUrl } });

    return false;
  }

  getSearchParam() {
    let searchParam = window.location.search;
    if (!searchParam) return false;
    searchParam = decodeURIComponent(searchParam);
    const sign = getParameterValue(searchParam, 'sign');
    const coid = getParameterValue(searchParam, 'coid');
    const redIsRise = getParameterValue(searchParam, 'redIsRise');
    return !!sign && !!coid && !!redIsRise
  }

}
